<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <!-- HEAD ADD User To Campaign -->
      <div class="content">
        <h1> {{$t('addUserToCampaign.title')}} </h1>
      </div>
      <hr>
      <div class="content">
        <label>{{$t('addUserToCampaign.userList')}}</label>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <div class="row">
          <div class="column">
            <div
              v-for="user in userSelectionList1"
              :key="user.title"
              class="row"
            >
              <label class="container">
                <input
                  type="checkbox"
                  v-model="user['toAdd']"
                />
                <span class="checkmark"></span>
                <p style="padding-right: 25px;">{{user['first-name'] + ' ' + user.name+ ' ('+user['user-profile-name'] +')'}}</p>
              </label>
              <br><br>
            </div>
          </div>
          <div class="column">
            <div
              v-for="user in userSelectionList2"
              :key="user.title"
              class="row"
            >
              <label class="container">
                <input
                  type="checkbox"
                  v-model="user['toAdd']"
                />
                <span class="checkmark"></span>{{user['first-name'] + ' ' + user.name+ ' ('+user['user-profile-name'] +')'}}
              </label>
              <br><br>
            </div>

          </div>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <button @click="addNewUsers()">{{$t('button.validate')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Users from "@/services/Users";
import axios from "axios";
export default {
  props: ["parCampaignId", "parUserList"],

  data() {
    return {
      userSelectionList1: [],
      userSelectionList2: [],
      isSubmitted: false,
      currentLang: this.$t("lang.fr.title"),
      addNewUser: false
    };
  },
  computed: {},
  mounted() {
    this.prepareListOfUser();
  },
  methods: {
    prepareListOfUser() {
      Users.getUsers().then(res => {
        if (res.status == 200) {
          if (!(this.parUserList == null || this.parUserList == [])) {
            var indexToRemove = -1;
            for (var i = 0; i < this.parUserList.length; i++) {
              indexToRemove = res.data.findIndex(
                x => x["id"] === this.parUserList[i]["id"]
              );
              if (indexToRemove != -1) res.data.splice(indexToRemove, 1);
            }
          }

          this.userSelectionList1 = res.data;
          if (this.userSelectionList1.length >= 1) {
            //sort by first name and name
            var sortedArray = this.userSelectionList1;
            sortedArray.sort(function(a, b) {
              if (
                (a["first-name"] + " " + a["name"]).toLowerCase() <
                (b["first-name"] + " " + b["name"]).toLowerCase()
              ) {
                return -1;
              }
              if (
                (a["first-name"] + " " + a["name"]).toLowerCase() >
                (b["first-name"] + " " + b["name"]).toLowerCase()
              ) {
                return 1;
              }
              return 0;
            });
            this.userSelectionList2 = sortedArray;
            var half_length = Math.ceil(this.userSelectionList2.length / 2);
            this.userSelectionList1 = this.userSelectionList2.splice(
              0,
              half_length
            );
          }
        }
      });
    },
    addNewUsers() {
      var userListToAdd = [];
      var mainObject = {};
      var promises = [];
      userListToAdd = this.userSelectionList1.concat(this.userSelectionList2);
      userListToAdd = userListToAdd.filter(x => x["toAdd"] == true);
      for (var i = 0; i < userListToAdd.length; i++) {
        promises.push(
          Users.addUserToCampaign(this.parCampaignId, userListToAdd[i]["id"])
        );
      }
      axios.all(promises).then(results => {
        results.forEach(function(response) {
          mainObject[response.identifier] = response.value;
        });
        this.$emit("newuseradded");
      });
    }
  }
};
</script>